var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13217_120250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16248 6.82908L7.8249 8.16667L9.16248 9.50425C9.39057 9.73233 9.39057 10.101 9.16248 10.3291C9.04873 10.4428 8.8994 10.5 8.75007 10.5C8.60073 10.5 8.4514 10.4428 8.33765 10.3291L7.00007 8.9915L5.66248 10.3291C5.54873 10.4428 5.3994 10.5 5.25007 10.5C5.10073 10.5 4.9514 10.4428 4.83765 10.3291C4.60957 10.101 4.60957 9.73233 4.83765 9.50425L6.17523 8.16667L4.83765 6.82908C4.60957 6.601 4.60957 6.23233 4.83765 6.00425C5.06573 5.77617 5.4344 5.77617 5.66248 6.00425L7.00007 7.34183L8.33765 6.00425C8.56573 5.77617 8.9344 5.77617 9.16248 6.00425C9.39057 6.23233 9.39057 6.601 9.16248 6.82908ZM13.4167 2.91667C13.4167 3.23925 13.1554 3.5 12.8334 3.5H12.3172L11.5728 11.3587C11.4299 12.8642 10.1816 14 8.66898 14H5.32823C3.81798 14 2.56965 12.8666 2.42498 11.3628L1.66898 3.5H1.16732C0.845318 3.5 0.583984 3.23925 0.583984 2.91667C0.583984 2.59408 0.845318 2.33333 1.16732 2.33333H3.55957C3.83082 1.00392 5.00915 0 6.41732 0H7.58398C8.99215 0 10.1711 1.00392 10.4417 2.33333H12.834C13.156 2.33333 13.4167 2.59408 13.4167 2.91667ZM4.76707 2.33333H9.23307C8.99215 1.65433 8.34407 1.16667 7.5834 1.16667H6.41673C5.65607 1.16667 5.00798 1.65433 4.76707 2.33333ZM11.1452 3.5H2.8409L3.5864 11.2507C3.67273 12.1532 4.42173 12.8333 5.32823 12.8333H8.66898C9.57665 12.8333 10.3257 12.152 10.4114 11.2478L11.1452 3.5Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13217_120250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete3);
export default __webpack_public_path__ + "static/media/delete3.a4fa41b0d6bea69beaa68187df8c22e2.svg";
export { ForwardRef as ReactComponent };